import { type IconType } from ".";

const EmailIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-none";
  const stroke = props.stroke ?? "stroke-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 26 26"
      width={25}
      height={25}
      className={`${props.size}`}
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <g id="Emails__x2F__Email-Actions__x2F__email-action-at">
        <g id="Group_44">
          <g id="email-action-at">
            <path
              id="Shape_171"
              d="M20.5 13.88V3.25c0-.83-.67-1.5-1.5-1.5H7c-.83 0-1.5.67-1.5 1.5v10.63"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_172"
              d="M22.28 12.46c.23-.18.53-.21.79-.09s.42.39.42.67v9.7c0 .83-.67 1.5-1.5 1.5H4c-.83 0-1.5-.67-1.5-1.5v-9.7c0-.29.16-.55.42-.67.26-.13.57-.09.79.09l7.43 5.89c1.09.85 2.62.85 3.71 0l7.43-5.89Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_173"
              d="M14.5 13.49c-1.85.65-3.91.04-5.09-1.53a4.502 4.502 0 0 1-.09-5.31 4.508 4.508 0 0 1 5.04-1.69c1.87.59 3.14 2.33 3.14 4.29"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Oval_9"
              d="M13 10.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_174"
              d="M14.5 9.25c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5"
              className={`cls-1 ${fill} ${stroke}`}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EmailIcon;
